(function () {

  function selectVariant(id) {
    if (!id) return;

    console.log('MENO → Variante seleccionada:', id);

    // Actualizar el input de la variante en el formulario
    document.querySelectorAll('input[name="id"]').forEach(input => {
      input.value = id;

      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    // Si el tema utiliza un selector de variantes
    document.querySelectorAll('select[name="id"]').forEach(select => {
      select.value = id;

      select.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    // Avisar al tema del cambio de variante
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        bubbles: true,
        detail: {
          variant: {
            id: id
          }
        }
      })
    );
  }


  function initOffers() {

    const offers = document.querySelectorAll(
      '.toplux-offer'
    );

    if (!offers.length) return;


    offers.forEach(card => {

      // Evitar registrar el evento dos veces
      if (card.dataset.topluxReady === 'true') return;

      card.dataset.topluxReady = 'true';


      card.addEventListener('click', function () {

        const variantId = this.dataset.variantId;

        if (!variantId) {
          console.error(
            'No se encontró data-variant-id en el pack.'
          );
          return;
        }


        // Quitar selección anterior
        offers.forEach(otherCard => {

          otherCard.classList.remove('selected');

          const radio = otherCard.querySelector(
            'input[type="radio"]'
          );

          if (radio) {
            radio.checked = false;
          }

        });


        // Seleccionar este pack
        this.classList.add('selected');

        const radio = this.querySelector(
          'input[type="radio"]'
        );

        if (radio) {
          radio.checked = true;
        }


        // Seleccionar la variante correspondiente
        selectVariant(variantId);

      });

    });

  }


  // Cargar normalmente
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initOffers
    );

  } else {

    initOffers();

  }


  // Para el editor de temas de Shopify
  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(initOffers, 100);
    }
  );

})();